import { observable, action } from "mobx";
import makeApi, { URLS } from "Utils/apiURL";
import { toasterState } from "../Components/common/toaster";

class TableConfigStore {
  @observable loading = false;
  @observable editLoader = "";
  tableConfigIds = {};

  @action
  async getTableHeaders(tableName = "") {
    this.loading = tableName;
    try {
      const config = {
        url: `${URLS.getTableHeaders}${tableName}`,
        method: "GET",
      };
      const response = await makeApi(config);
      const { data = {} } = response || {};
      this.tableConfigIds = {
        ...this.tableConfigIds,
        [tableName]: data.id,
      };
      return data?.columns || [];
    } finally {
      this.loading = "";
    }
  }

  // creates/edits
  @action
  async editTableHeaders({ tableName = "", columns = [] }) {
    this.editLoader = tableName;
    const config = {
      url: URLS.editTableHeaders,
      method: "POST",
      data: {
        id: this.tableConfigIds[tableName],
        tableName,
        columns,
      },
    };
    const response = await makeApi(config);
    const { data = {} } = response || {};
    this.tableConfigIds = {
      ...this.tableConfigIds,
      [tableName]: data.id,
    };
    if (response.status !== 200)
      toasterState.setToastMsg("Updating table headers failed", "failure");
    else
      toasterState.setToastMsg("Table headers saved successfully", "success");
    this.editLoader = "";
    return data?.columns || [];
  }
}

const tableConfigStore = new TableConfigStore();

export default tableConfigStore;
